import React, { useState } from "react";
import "../styles/SignInPage.css";
import logoIcon from "../assets/mainicon.png";
import googleIcon from "../assets/googleicon.png";
import facebookIcon from "../assets/facebookicon.png";
import emailIcon from "../assets/Message.png";
import passwordIcon from "../assets/Lock.png";
import viewIcon from "../assets/Show.png";
import hideIcon from "../assets/Hide.png";
import { auth, provider, db } from "../firebaseConfig";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { signInWithEmailAndPassword, signInWithPopup } from "firebase/auth";
import { useNavigate } from "react-router-dom";
const SignInPage = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [prompt] = useState("");
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleSignIn = async () => {
    setError("");
    setSuccess("");

    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );
      const user = userCredential.user;
      console.log("User signed in:", user);
      localStorage.setItem("user", JSON.stringify(user));

      const userDocRef = doc(db, "users", user.uid);
      const userDocSnapshot = await getDoc(userDocRef);
      if (userDocSnapshot.exists()) {
        const userData = userDocSnapshot.data();
        localStorage.setItem("points", userData.points);
      }
      setSuccess("User signed in successfully!");
      navigate("/process");
    } catch (error) {
      console.error("Error signing in:", error);
      setError(error.message);
    }
  };

  const handleGoogleSignIn = async () => {
    setError("");
    setSuccess("");

    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      const userDocRef = doc(db, "users", user.uid);
      const userDocSnapshot = await getDoc(userDocRef);

      if (userDocSnapshot.exists()) {
        const userData = userDocSnapshot.data();
        console.log("Signin with google data ", userData);
        localStorage.setItem("points", userData.points);
      } else {
        // If user document does not exist, initialize points
        await setDoc(userDocRef, {
          username: user.displayName || "Google User",
          email: user.email,
          points: 50,
        });
        console.log("User got 50 points");
        localStorage.setItem("points", 50);
      }

      localStorage.setItem("user", JSON.stringify(user));
      console.log("User signed in with Google:", user);
      setSuccess("User signed in with Google successfully!");
      navigate("/process", { state: { prompt } });
    } catch (error) {
      console.error("Error signing in with Google:", error);
      setError(error.message);
    }
  };

  return (
    <div className="login-page">
      <header className="header1">
        <div className="logo">
          <a href="/">
            <img src={logoIcon} alt="Logo" className="logo-icon" />
            <h1 className="logo-text">Art Generator</h1>
          </a>
        </div>
      </header>

      <div className="login-box">
        <h2 className="welcome-textt">Welcome Back!</h2>
        <div className="social-buttons">
          <button className="social-button" onClick={handleGoogleSignIn}>
            <img src={googleIcon} alt="Google" className="social-icon" />
            Continue with Google
          </button>
          <button className="social-button">
            <img src={facebookIcon} alt="Facebook" className="social-icon" />
            Continue with Facebook
          </button>
        </div>
        <p className="or-continue-text">
          <span className="line-image"></span> or sign in with{" "}
          <span className="line-image"></span>
        </p>
        <div className="input-container1">
          <div className="input-box">
            <img src={emailIcon} alt="Email" className="input-icon" />
            <input
              type="text"
              placeholder="Enter Email Address"
              className="text-input1"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="input-box">
            <img src={passwordIcon} alt="Password" className="input-icon" />
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Enter Password"
              className="text-input1"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <img
              src={showPassword ? viewIcon : hideIcon}
              alt="Toggle Password"
              className="toggle-icon"
              onClick={togglePasswordVisibility}
            />
          </div>
        </div>
        {error && <p style={{ color: "red" }}>{error}</p>}
        {success && <p style={{ color: "green" }}>{success}</p>}
        <button className="signin-button" onClick={handleSignIn}>
          Sign In
        </button>
        <p className="signup-text">
          Don't have an account? <a href="/signup">Sign Up</a>
        </p>
      </div>
    </div>
  );
};

export default SignInPage;
